import React, { useEffect, useState, useMemo } from 'react';
import MUIDataTable from 'mui-datatables';
import axios from 'axios';
import config from '../config/config';
import {
  Menu,
  MenuItem,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useNavigate } from 'react-router-dom';

const Students = () => {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  const navigate = useNavigate();

  const fetchStudents = async (page = 0, rowsPerPage = 10, searchText = '') => {
    setLoading(true);
    const token = localStorage.getItem('token');

    try {
      const res = await axios.get(config.API_URL+'/api/pullinvoices', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          page: page + 1,
          per_page: rowsPerPage,
          search: searchText,
        },
      });

      setData(res.data.data);
      setTotal(res.data.total);
    } catch (err) {
      console.error('Error fetching invoices:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStudents(page, rowsPerPage, searchText);
  }, [page, rowsPerPage, searchText]);

  const handleMenuClick = (event, student) => {
    event.stopPropagation(); // Prevents triggering onRowClick
    setAnchorEl(event.currentTarget);
    setSelectedStudent(student);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleView = () => {
    setOpenModal(true);
    handleMenuClose();
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const columns = useMemo(
    () => [
      { name: 'id', label: 'ID' },
       { name: 'reference_no', label: 'Reference No' },
      { name: 'admission_number', label: 'Admission No' },
      { name: 'name', label: 'Name' },
      { name: 'grand_total', label: 'Fee Amount' },
      { name: 'paid_amount', label: 'Fee Paid' },
      { name: 'balance', label: 'Balance' },
      { name: 'created_at', label: 'Invoiced On' },
      { name: 'due_date', label: 'Due On' },
      
    ],
    [data]
  );

  const options = useMemo(
    () => ({
      search: false,
      filter: true,
      download: true,
      print: true,
      pagination: true,
      serverSide: true,
      count: total,
      rowsPerPage: rowsPerPage,
      page: page,
      onTableChange: (action, tableState) => {
        switch (action) {
          case 'changePage':
            setPage(tableState.page);
            break;
          case 'changeRowsPerPage':
            setRowsPerPage(tableState.rowsPerPage);
            setPage(0);
            break;
          default:
            break;
        }
      },
      onRowClick: (rowData, rowMeta) => {
        const student = data[rowMeta.dataIndex];
        navigate(`/students/${student.id}/viewinvoice`);
      },
    }),
    [total, page, rowsPerPage, data, navigate]
  );

  return (
    <div>
      <input
        type="text"
        placeholder="Search invoices by admission / student name..."
        value={searchText}
        onChange={(e) => {
          setSearchText(e.target.value);
          setPage(0); // Reset to first page on search
        }}
        style={{ marginBottom: '16px', padding: '8px', width: '300px' }}
      />

      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
          <CircularProgress />
        </div>
      ) : (
        <MUIDataTable title={'Students'} data={data} columns={columns} options={options} />
      )}

      <Menu
        id="actions-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
       
      </Menu>

     
    </div>
  );
};

export default Students;
